import React, { createContext, useContext, useState } from 'react';

const RevenueViewContext = createContext(null);

export const RevenueViewProvider = ({ children }) => {
  const [view, setView] = useState('full'); // 'full' | 'talent' | 'agency'
  return (
    <RevenueViewContext.Provider value={{ view, setView }}>
      {children}
    </RevenueViewContext.Provider>
  );
};

export const useRevenueView = () => {
  const c = useContext(RevenueViewContext);
  if (!c) return { view: 'full', setView: () => {} };
  return c;
};
